import React from "react";
import { Link, useLocation } from "react-router-dom";

const EducationCategoryNavbar = () => {
  const location = useLocation(); // Get current path

  return (
    <div className="text-start mb-2 catnav">
      <Link
        className={`nacs catitm me-2 ${location.pathname === "/admin/all-education-category" ? "activecat" : ""}`}
        to="/admin/all-education-category"
        data-discover="true"
      >
       All Education Category
      </Link>



      <Link
        className={`nacs catitm me-2 ${location.pathname === "/admin/education-category" ? "activecat" : ""}`}
        to="/admin/education-category"
        data-discover="true"
      >
        What we do
      </Link>

      <Link
        className={`nacs catitm me-2 ${location.pathname === "/admin/education-sub-category" ? "activecat" : ""}`}
        to="/admin/education-sub-category"
        data-discover="true"
      >
       Category 
      </Link>


      <Link
        className={`nacs catitm me-2 ${location.pathname === "/admin/admin/education-sub-sub-category" ? "activecat" : ""}`}
        to="/admin/education-sub-sub-category"
        data-discover="true"
      >
       Sub Category
      </Link>
 


 <Link
        className={`nacs catitm me-2 ${location.pathname === "/admin/admin/education-sub-sub-sub-category" ? "activecat" : ""}`}
        to="/admin/education-sub-sub-sub-category"
        data-discover="true"
      >
       Sub Sub Category
      </Link>


 
      {/* <Link
        className={`nacs catitm me-2 ${location.pathname === "/admin/ten-category" ? "activecat" : ""}`}
        to="/admin/ten-category"
        data-discover="true"
      >
        10th Level Category
      </Link> */}

      
      

      
      


    </div>
  );
};

export default EducationCategoryNavbar;
